import {
    ADD_INSTANCE_DATA_SUCCESS,
    ADD_INSTANCE_DATA_FAILURE,
    FETCH_ESG_RESULTS_SUCCESS,
    FETCH_ESG_RESULTS_FAILURE,
} from './constants';

import {
    SET_APP_LOADING_PENDING,
    SET_APP_LOADING_COMPLETE,
} from '@/store';

import * as interactionService from '@/services/interaction'
import * as resultsService from '@/services/results'

const actions = {

    async fetchBQAParticipantResults(_, payload) {
        const { interactionInstanceToken, locale } = payload;
        return await resultsService.fetchBQAParticipantResults(interactionInstanceToken, locale)
    },

    async fetchESGResults({ commit }, payload) {
        const { interactionInstanceToken } = payload; 
        try {
            const results = await resultsService.fetchESGResults(interactionInstanceToken)
            commit(FETCH_ESG_RESULTS_SUCCESS, results)
        } catch(e) {
            commit(FETCH_ESG_RESULTS_FAILURE)
            throw e
        }
    },
    async addInstanceAdditionalData({ commit }, payload) {
        const { interactionInstanceToken, data } = payload;
        try {
            await interactionService.addInteractionInstanceData(interactionInstanceToken, data)
            commit(ADD_INSTANCE_DATA_SUCCESS)
        } catch(e) {
            console.error(e)
            commit(ADD_INSTANCE_DATA_FAILURE)
        }
    }
}

export default actions